import { render, staticRenderFns } from "./BotaoTabelaDePrecos.vue?vue&type=template&id=5b0d10c6&scoped=true&"
import script from "./BotaoTabelaDePrecos.vue?vue&type=script&lang=js&"
export * from "./BotaoTabelaDePrecos.vue?vue&type=script&lang=js&"
import style0 from "./BotaoTabelaDePrecos.vue?vue&type=style&index=0&id=5b0d10c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d10c6",
  null
  
)

export default component.exports